import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSitemap, faUsers, faBuilding, faUserTie } from '@fortawesome/free-solid-svg-icons';
import OrganisationIMG from './../../assets/organisation.jpg';
import footerBg from "./../../assets/footerbg.jpg";
const Organisation = () => (
  <><div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin:'2%',
        borderRadius:'10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faSitemap} className="me-2" />
            Organisation Structure
          </h3>
        </Container>
      </div>
    
    <Container className="py-5">
      {/* Info Cards */}
      <Row className="mb-5">
        <Col md={4} className="mb-3">
          <div className="text-center p-4" style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            borderRadius: '16px',
            boxShadow: '0 8px 25px rgba(30,60,114,0.3)',
            color: 'white'
          }}>
            <FontAwesomeIcon icon={faBuilding} style={{fontSize: '2.5rem', marginBottom: '15px', color: 'white'}} />
            <h5 className="fw-bold mb-1">Head Office</h5>
            <small style={{opacity: 0.9}}>Panchkula, Haryana</small>
          </div>
        </Col>
        <Col md={4} className="mb-3">
          <div className="text-center p-4" style={{
            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
            borderRadius: '16px',
            boxShadow: '0 8px 25px rgba(22,160,133,0.3)',
            color: 'white'
          }}>
            <FontAwesomeIcon icon={faUsers} style={{fontSize: '2.5rem', marginBottom: '15px', color: 'white'}} />
            <h5 className="fw-bold mb-1">District Offices</h5>
            <small style={{opacity: 0.9}}>22 Districts Covered</small>
          </div>
        </Col>
        <Col md={4} className="mb-3">
          <div className="text-center p-4" style={{
            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
            borderRadius: '16px',
            boxShadow: '0 8px 25px rgba(142,68,173,0.3)',
            color: 'white'
          }}>
            <FontAwesomeIcon icon={faSitemap} style={{fontSize: '2.5rem', marginBottom: '15px', color: 'white'}} />
            <h5 className="fw-bold mb-1">Structure</h5>
            <small style={{opacity: 0.9}}>3-Tier System</small>
          </div>
        </Col>
      </Row>
      
      {/* Organisation Chart Image */}
      <div className="text-center">
        <div style={{
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          borderRadius: '20px',
          boxShadow: '0 12px 40px rgba(0,0,0,0.1)',
          padding: '40px',
          border: '1px solid rgba(255,255,255,0.5)'
        }}>
          <h4 className="fw-bold mb-4" style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: '1.8rem'
          }}>Department Organisation Structure</h4>
          <img 
            src={OrganisationIMG} 
            alt='Organisation Chart' 
            style={{ 
              width: '100%', 
              maxWidth: '900px',
              borderRadius: '12px',
              boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
            }} 
          />
          <p className="mt-4" style={{fontSize: '1rem', color: '#6c757d'}}>
            <i className="fas fa-info-circle me-2" style={{color: '#667eea'}}></i>
            Organisation chart showing the complete hierarchy from Additional Chief Secretary to District level officers
          </p>
        </div>
      </div>
    </Container>
  </>
);

export default Organisation;
